// extracted by mini-css-extract-plugin
export default {"content":"UserManagementDialog_content__7IxNt"};